import { createSlice } from '@reduxjs/toolkit';

const organizerLogsSlice = createSlice({
    name: 'organizerLogs',
    initialState: {
        logs: [], // Array of log entries with tree structure
    },
    reducers: {
        addLogs: (state, action) => {
            if (Array.isArray(action.payload)) {
                state.logs = [...action.payload, ...state.logs];
            } else {
                state.logs = [action.payload, ...state.logs];
            }
        },
        updateOrAddLogs: (state, action) => {
            if (Array.isArray(action.payload) && action.payload.length > 0) {
                action.payload.forEach(newLog => {
                    if (newLog.status === 'separator' || newLog.status === 'summary') {
                        return; // Skip these
                    }
                    if (newLog.filePath) {
                        const existingIndex = state.logs.findIndex(log => log.filePath === newLog.filePath);
                        if (existingIndex !== -1) {
                            state.logs[existingIndex] = newLog; // Update
                        } else {
                            state.logs = [newLog, ...state.logs]; // Add at beginning
                        }
                    }
                });
            }
        },
        removeLogsForFile: (state, action) => {
            // A tree row may be keyed by the original path or the post-organize
            // path, so drop any log entry whose filePath/newPath/targetPath matches.
            const path = action.payload;
            state.logs = state.logs.filter(
                (log) =>
                    !log ||
                    (log.filePath !== path &&
                        log.newPath !== path &&
                        log.targetPath !== path)
            );
        },
        clearLogs: (state) => {
            state.logs = [];
        },
        addLogsLineBreak: (state) => {
            state.logs = [{ msg: '\n', status: 'separator' }, ...state.logs];
        },
    },
});

export const {
    addLogs,
    updateOrAddLogs,
    removeLogsForFile,
    clearLogs,
    addLogsLineBreak,
} = organizerLogsSlice.actions;

export default organizerLogsSlice.reducer;
